<template>
  <div class="about">
    <!-- 固定头部导航 -->
    <!-- <nav class="anchor-navbar" ref="anchorNavbar">
      <ul class="anchor-list">
       
        <li class="display-only">{{ sections[0].label }}</li>

      
        <li
          v-for="(item, index) in sections.slice(1)"
          :key="index + 1"
          :class="{ active: activeSection === item.id }"
          @click="scrollToSection(item,index)"
        >{{ item.label }}</li>
      </ul>
    </nav>-->
    <div ref="anchorDetail">
      <!-- 关于我们 -->
      <section class="vision" id="section-1" ref="section1">
        <div class="vision-container">
          <div class="vision-container-text" ref="missionContainer">
            <div class="vision-container-wrap" ref="missionWrap">
              <div class="vision-container-text-title">
                <div>{{ $t('message.aboutMissionTitle') }}</div>
              </div>
              <div class="vision-container-text-detail">{{ $t('message.aboutMissionHint') }}</div>
              <div style="margin-top: 0.937rem;" class="vision-container-text-detail">{{ $t('message.aboutMissionHint1') }}</div>
            </div>
          </div>
          <div class="vision-container-image" :style="{ backgroundImage: `url(${currentBg})` }">
            <div style="height:60vw; color:transparent">11111</div>
          </div>
        </div>

        <!-- 简介区域 -->
        <div class="brief" ref="briefContainer">
          <div class="brief-frame" ref="briefFrame">
            <h1 class="brief-title">{{ $t('message.aboutBriefTitle') }}</h1>
            <p class="brief-content">{{ $t('message.aboutBriefHint1') }}</p>
            <p class="brief-content">{{ $t('message.aboutBriefHint2') }}</p>
            <p class="brief-content" style="margin-bottom: 0px !important;">{{ $t('message.aboutBriefHint3') }}</p>
          </div>
        </div>
      </section>

      <!-- 轮播图 -->
      <section id="section-2" ref="section2">
        <ImageCarousel />
        <!-- 知识产权区域 -->
        <div class="ip">
          <div class="ip-frame">
            <h1 class="ip-title">{{ $t('message.aboutIPTitle') }}</h1>
            <div class="ip-line"></div>
            <div class="ip-detail">
              <About_IPDetail_Item :item_name="IPFiled" :item_value="'168'" />
              <About_IPDetail_Item :item_name="IPGranted" item_value="88" />
              <About_IPDetail_Item :item_name="IPReview" item_value="100" />
            </div>
          </div>
        </div>
      </section>

      <section class="locationSection" id="section-2" ref="section3">
        <div class="locationTitle">{{ $t('message.aboutLocationTitle') }}</div>
        <!-- 办公地点区域 -->
        <div class="location">
          <div style="flex:1">
            <About_Location_Item
              :item_loc_img="LocShaoxing.loc_img"
              :item_loc_name="LocShaoxing.loc_name"
              :item_loc_type="LocShaoxing.loc_type"
              :item_loc_addr="LocShaoxing.loc_addr"
              :item_loc_phone="LocShaoxing.loc_phone"
              :item_loc_web="LocShaoxing.loc_web"
              :item_loc_detail01="LocShaoxing.loc_detail01"
              :item_loc_detail02="LocShaoxing.loc_detail02"
              :item_loc_detail03="LocShaoxing.loc_detail03"
            />
          </div>
          <div style="flex:1">
            <About_Location_Item
              :item_loc_img="LocHangzhou.loc_img"
              :item_loc_name="LocHangzhou.loc_name"
              :item_loc_type="LocHangzhou.loc_type"
              :item_loc_addr="LocHangzhou.loc_addr"
              :item_loc_phone="LocHangzhou.loc_phone"
              :item_loc_web="LocHangzhou.loc_web"
              :item_loc_detail01="LocHangzhou.loc_detail01"
              :item_loc_detail02="LocHangzhou.loc_detail02"
              :item_loc_detail03="LocHangzhou.loc_detail03"
              :item_loc_detail04="LocHangzhou.loc_detail04"
            />
          </div>
        </div>

        <div class="location specialMargin">
          <div style="flex:1">
            <About_Location_Item
              :item_loc_img="LocJinhua.loc_img"
              :item_loc_name="LocJinhua.loc_name"
              :item_loc_type="LocJinhua.loc_type"
              :item_loc_addr="LocJinhua.loc_addr"
              :item_loc_phone="LocJinhua.loc_phone"
              :item_loc_web="LocJinhua.loc_web"
              :item_loc_detail01="LocJinhua.loc_detail01"
              :item_loc_detail02="LocJinhua.loc_detail02"
              :item_loc_detail03="LocJinhua.loc_detail03"
            />
          </div>
          <div style="flex:1">
            <About_Location_Item
              :item_loc_img="LocShenzhen.loc_img"
              :item_loc_name="LocShenzhen.loc_name"
              :item_loc_type="LocShenzhen.loc_type"
              :item_loc_addr="LocShenzhen.loc_addr"
              :item_loc_phone="LocShenzhen.loc_phone"
              :item_loc_web="LocShenzhen.loc_web"
              :item_loc_detail01="LocShenzhen.loc_detail01"
              :item_loc_detail02="LocShenzhen.loc_detail02"
              :item_loc_detail03="LocShenzhen.loc_detail03"
              :item_loc_detail04="LocShenzhen.loc_detail04"
            />
          </div>
        </div>
      </section>
      <section class="ourInvesters" ref="ourInvesters">
        <div class="ourInvestersTitle">OUR INVESTERS</div>
        <div class="ourInvestersLogoContainer">
          <img class="ourInvestersLogo" src="../assets/images/about/invester-zhongdi.png" alt="Zhongdi Investment" />
          <img class="ourInvestersLogo" src="../assets/images/about/invester-yuankun.png" alt="Yuankun Taihe" />
          <img class="ourInvestersLogo" src="../assets/images/about/invester-zhongjin.png" alt="CICC Capital" />
          <img class="ourInvestersLogo" src="../assets/images/about/invester-chuangrui.png" alt="Creation Investment" />
          <img class="ourInvestersLogo" src="../assets/images/about/invester-yuecheng.png" alt="YuechengFa" />
          <img class="ourInvestersLogo" src="../assets/images/about/invester-zhenghong.png" alt="Zhenghong Fund" />
          <img class="ourInvestersLogo" src="../assets/images/about/invester-qidi.png" alt="Tus Star" />
          <img class="ourInvestersLogo" src="../assets/images/about/invester-shunan.png" alt="Shunan Investment" />
        </div>
      </section>
      <section class="addContract">
        <div class="contractTitle">CONTACT US</div>
        <div class="form-container">
          <form @submit.prevent="handleSubmit">
            <div class="form-row">
              <div class="form-item">
                <label>
                  <span class="required">*</span> Name
                </label>
                <input type="text" v-model="form.name" placeholder="Enter Your Name" />
              </div>
              <div class="form-item">
                <label>
                  <span class="required">*</span> Tel
                </label>
                <input type="tel" v-model="form.phone" placeholder="Enter Your Phone" />
              </div>
              <div class="form-item">
                <label>
                  <span class="required">*</span> E-mail
                </label>
                <input type="email" v-model="form.email" placeholder="Enter Your Email" />
              </div>
            </div>
            <div class="form-row">
              <div class="form-item full-width">
                <label>
                  <span class="required">*</span> Address
                </label>
                <input type="text" v-model="form.address" placeholder="Enter Your Address" />
              </div>
            </div>
            <div class="form-row submit-row">
              <button type="submit">Submit</button>
            </div>
          </form>
        </div>
      </section>
    </div>
  </div>
</template>

<script setup>
import About_IPDetail_Item from '../views/About_IPDetail_Item.vue'
import About_Location_Item from '../views/About_Location_Item.vue'
import ImageCarousel from '@/components/carousel.vue'
import { gsap } from 'gsap'
import axios from 'axios'
</script>

<script>
export default {
  name: 'AppAbout',
  data() {
    return {
      isMobile: window.innerWidth <= 768,
      form: {
        name: '',
        phone: '',
        email: '',
        address: ''
      },
      lowResBg: require('@/assets/images/about/team-low.jpg'), // 压缩图
      highResBg: require('@/assets/images/about/team.png'), // 高清图
      currentBg: '', // 当前显示的背景
      IPFiled: this.$t('message.aboutIPFiled'),
      IPGranted: this.$t('message.aboutIPGranted'),
      IPReview: this.$t('message.aboutIPReview'),
      LocShaoxing: this.$t('message.aboutLocationShaoxing'),
      LocHangzhou: this.$t('message.aboutLocationHangzhou'),
      LocJinhua: this.$t('message.aboutLocationJinhua'),
      LocShenzhen: this.$t('message.aboutLocationShenzhen'),
      lastScrollY: 0, // 上一次滚动位置
      scrollDirection: null, // "down" 或 "up"
      lastScrollTime: 0,
      sections: [
        { label: 'About US', content: '展示内容', id: 0 },
        { label: 'About us ', content: '内容1', id: 1 },
        { label: 'Honor', content: '内容2', id: 2 },
        { label: 'Company Address', content: '内容3', id: 3 }
      ],
      activeSection: 1,
      isManualScroll: true, // 新增标志位，默认手动滚动
      wrapperTop: 0,
      wrapperHeight: 0
    }
  },
  mounted() {
    this.initLocationAnimation()
    this.initInvestersAnimation()
    this.$nextTick(() => {
      const container = this.$refs.briefContainer
      const frame = this.$refs.briefFrame
      const items = frame.querySelectorAll('.brief-content, .brief-title')

      if (!container || !frame) return

      // 初始位置在下方更低，透明
      gsap.set(items, { y: 80, opacity: 0 })

      // 定义动画时间线
      const tl = gsap.timeline({ paused: true })
      tl.to(items, {
        y: 0,
        opacity: 1,
        duration: 0.8,
        ease: 'power3.out',
        stagger: 0.15 // 每个文字段落依次进入
      })

      // 监听滚动进入视口
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            tl.play()
          } else {
            // 离开时复位（可选）
            gsap.set(items, { y: 80, opacity: 0 })
            tl.pause(0)
          }
        },
        { threshold: 0.1 }
      )

      observer.observe(container)

      const missionContainer = this.$refs.missionContainer
      const missionWrap = this.$refs.missionWrap
      if (!missionContainer || !missionWrap) return

      const missionItems = missionWrap.querySelectorAll('.vision-container-text-title, .vision-container-text-detail')

      // 初始状态：向下偏移 + 透明
      gsap.set(missionItems, { y: 80, opacity: 0 })

      // 定义动画时间线
      const missionTl = gsap.timeline({ paused: true })
      missionTl.to(missionItems, {
        y: 0,
        opacity: 1,
        duration: 0.8,
        ease: 'power3.out',
        stagger: 0.15 // 依次淡入
      })

      // 监听滚动触发
      const missionObserver = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            missionTl.play()
          } else {
            // 离开时复位（可选）
            gsap.set(missionItems, { y: 80, opacity: 0 })
            missionTl.pause(0)
          }
        },
        { threshold: 0.15 }
      )

      missionObserver.observe(missionContainer)

      // 获取 wrapper
      const wrapper = Array.isArray(this.$refs.wrapper) ? this.$refs.wrapper[0] : this.$refs.wrapper
      if (wrapper) {
        this.wrapperTop = wrapper.offsetTop
        this.wrapperHeight = wrapper.offsetHeight
      }

      window.addEventListener('scroll', this.onScroll)
      window.addEventListener('resize', this.onResize)
      this.setAnchorOffset()

      // 页面先显示压缩图
      this.currentBg = this.lowResBg

      // 异步加载高清图
      const img = new Image()
      img.src = this.highResBg
      img.onload = () => {
        // 高清图加载完成后替换
        this.currentBg = this.highResBg
      }
    })
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll)
    window.removeEventListener('resize', this.onResize)
  },
  methods: {
    initInvestersAnimation() {
      this.$nextTick(() => {
        const section = this.$refs.ourInvesters
        if (!section) return

        const title = section.querySelector('.ourInvestersTitle')
        const logos = Array.from(section.querySelectorAll('.ourInvestersLogo'))

        // 初始化
        gsap.set([title, ...logos], { y: 50, opacity: 0 })

        const tl = gsap.timeline({ paused: true })

        // 标题稍快一点出现
        tl.to(title, {
          y: 0,
          opacity: 1,
          duration: 0.5,
          ease: 'power2.out'
        })

        // 响应式分组
        const isMobile = window.innerWidth <= 768
        const groupSize = isMobile ? 2 : 4

        // 每组 logo 同时出现，组间无明显停顿
        for (let i = 0; i < logos.length; i += groupSize) {
          const group = logos.slice(i, i + groupSize)
          tl.to(
            group,
            {
              y: 0,
              opacity: 1,
              duration: 0.4, // 更快
              ease: 'power2.out',
              stagger: 0.05 // 组内轻微错位
            },
            '-=0.2'
          ) // 减少组间延迟，整体连贯
        }

        // 视口触发
        const observer = new IntersectionObserver(
          ([entry]) => {
            if (entry.isIntersecting) {
              tl.play()
              observer.unobserve(section)
            }
          },
          { threshold: 0.2, rootMargin: '0px 0px -10% 0px' }
        )

        observer.observe(section)

        // 移动端保险触发
        const checkVisible = () => {
          const rect = section.getBoundingClientRect()
          if (rect.top < window.innerHeight * 0.8) {
            tl.play()
            window.removeEventListener('scroll', checkVisible)
          }
        }
        window.addEventListener('scroll', checkVisible, { passive: true })
      })
    },

    initLocationAnimation() {
      this.$nextTick(() => {
        const section = this.$refs.section3
        if (!section) return

        const title = section.querySelector('.locationTitle')
        const rows = section.querySelectorAll('.location')

        // 初始化状态：下移 + 透明
        gsap.set([title, ...rows], { y: 80, opacity: 0 })

        // 时间线
        const tl = gsap.timeline({ paused: true })
        tl.to(title, {
          y: 0,
          opacity: 1,
          duration: 0.8,
          ease: 'power3.out'
        })
        rows.forEach(row => {
          tl.to(
            row,
            {
              y: 0,
              opacity: 1,
              duration: 0.8,
              ease: 'power3.out'
            },
            '-=0.6'
          )
        })

        // IntersectionObserver
        const observer = new IntersectionObserver(
          ([entry]) => {
            if (entry.isIntersecting) {
              tl.play()
              observer.unobserve(section)
            }
          },
          {
            threshold: 0.2,
            // 让移动端提早触发动画（视口外提前开始）
            rootMargin: '0px 0px -10% 0px'
          }
        )

        observer.observe(section)

        // ✅ 移动端保险机制：监听滚动手动触发
        const checkVisible = () => {
          const rect = section.getBoundingClientRect()
          if (rect.top < window.innerHeight * 0.8) {
            tl.play()
            window.removeEventListener('scroll', checkVisible)
          }
        }
        window.addEventListener('scroll', checkVisible, { passive: true })
      })
    },

    async handleSubmit() {
      const apiBase = process.env.NODE_ENV === 'production' ? 'https://www.meiomedical.com/api' : 'https://www.meiomedical.com/api'

      const url = `${apiBase}/consultations`

      if (!this.form.name || !this.form.phone || !this.form.email || !this.form.address) {
        alert('Please complete all required form fields.')
        return
      }

      const phoneRegex = /^1[3-9]\d{9}$/
      if (!phoneRegex.test(this.form.phone)) {
        alert('Please enter a valid phone number.')
        return
      }

      // 发送前打印
      console.log('提交数据:', this.form)

      try {
        const response = await axios.post(
          url,
          {
            name: this.form.name,
            phone: this.form.phone, // ✅ 后端要求字段是 tel
            email: this.form.email,
            address: this.form.address
          },
          {
            headers: {
              'Content-Type': 'application/json'
            },
            // 防缓存参数（可选）
            // params: { _: Date.now() },
            timeout: 10000 // 超时 10 秒
          }
        )

        const data = response.data
        console.log(data)
        alert(data.msg == 'success' ? 'Submission successful.' : data.msg || '未知错误')
        // if (data.status === 'ok') {
        //   alert('提交成功！')
        //   this.form = { name: '', phone: '', email: '', address: '' }
        // } else {
        //   alert('提交失败：' + (data.msg || '未知错误'))
        // }
      } catch (err) {
        console.error('Submission error:', err)
        if (err.response) {
          alert(`Server error (${err.response.status})`)
        } else if (err.request) {
          alert('Unable to connect to the server. Please check your network connection.')
        } else {
          alert('Request error:' + err.message)
        }
      }
    },

    scrollToSection(item) {
      const sectionEl = this.$refs[`section${item.id}`]
      if (sectionEl) {
        sectionEl.scrollIntoView({ behavior: 'smooth', block: 'start' })
        this.activeSection = item.id
      }
    },
    onScroll() {
      const scrollY = window.scrollY
      // 在最顶部时，高亮第一个
      if (scrollY === 0) {
        this.activeSection = 1
        return
      }
      const offsets = [
        this.$refs.section1?.offsetTop || 0,
        this.$refs.section2?.offsetTop || 0,
        this.$refs.section3?.offsetTop || 0,
        this.$refs.section4?.offsetTop || 0
      ]
      const current = offsets.findIndex((offset, i) => {
        const nextOffset = offsets[i + 1] || Number.MAX_VALUE
        return scrollY >= offset - 100 && scrollY < nextOffset - 100
      })
      if (current >= 0) {
        this.activeSection = current + 1
      }
    },

    setAnchorOffset() {
      const logoEl = document.querySelector('.navbar-logo')
      // const navbar = document.querySelector('.navbar')
      if (logoEl) {
        // const rect = logoEl.getBoundingClientRect()
        // this.$refs.anchorNavbar.style.paddingLeft = rect.left - 20 + 'px'
        // this.$refs.anchorNavbar.style.top = navbar.offsetHeight + 'px'
        this.$refs.anchorDetail.style.marginTop = logoEl.offsetHeight + 20 + 'px'
      }
    },
    onResize() {
      this.$nextTick(() => {
        const wrapper = Array.isArray(this.$refs.wrapper) ? this.$refs.wrapper[0] : this.$refs.wrapper
        if (wrapper) {
          this.wrapperTop = wrapper.offsetTop
          this.wrapperHeight = wrapper.offsetHeight
        }
        this.setAnchorOffset()
      })
    }
  }
}
</script>

<style scoped>
.addContract {
  border-top: 1px solid #d1c7c7;
  padding-top: 5rem;
  width: 63vw;
  margin: 0 auto;
  margin-top: 9rem;
}

.form-container {
  font-family: 'D-DIN-PRO', sans-serif;
}

.form-row {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 6rem;
  gap: 1.25rem; /* 设置间距，替代 margin-right */
}

.form-item {
  flex: 1 1 200px; /* 自动换行，最小宽度 200px */
  display: flex;
  flex-direction: column;
}

.full-width {
  flex: 1 1 100%;
}

label {
  margin-bottom: 5px;
  font-size: 14px;
  color: #333;
  font-size: 1.2rem;
  font-weight: 400;
}

.required {
  color: red;
  margin-right: 3px;
}

input {
  height: 36px;
  padding: 0 1rem;
  border: none;
  border-bottom: 1px solid #ccc;
  font-size: 14px;
  outline: none;
}

input:focus {
  border-bottom: 1px solid #003a74; /* 深蓝色 */
}

.submit-row {
  display: flex;
  justify-content: center;
}

button {
  background-color: #000;
  color: #fff;
  border: none;
  border-radius: 1.25rem;
  padding: 10px 40px;
  cursor: pointer;
  font-size: 1rem;
}

button:hover {
  opacity: 0.8;
}

.locationTitle {
  text-align: center;
  width: 62vw;
  margin: 0 auto;
  font-size: var(--title-font-size);
  font-weight: bolder;
  margin-bottom: 6.25rem;
}
.contractTitle {
  text-align: center;
  width: 62vw;
  margin: 0 auto;
  font-size: var(--title-font-size);
  font-weight: bolder;
  margin-bottom: 6.25rem;
}

.specialMargin {
  margin-top: 10rem !important;
}

.anchor-navbar {
  position: fixed;
  /* top: 60px; */
  width: 100%;
  height: 55px;
  background-color: #111827;
  display: flex;
  align-items: center;
  z-index: 3;
  font-size: var(--header-size);
}
.anchor-list {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
}
.anchor-list li {
  margin: 0 var(--title-font-size);
  color: #9ca3af;
  cursor: pointer;
  font-weight: 500;
  transition: color 0.3s, border-bottom 0.3s;
  padding-bottom: 4px;
  position: relative;
}
.anchor-list li:hover {
  color: #00acf8;
}
.anchor-list li::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: #00acf8;
  transform: scaleX(0);
  transform-origin: center;
  transition: transform 0.3s;
}
.anchor-list li:hover::after {
  transform: scaleX(1);
}
.anchor-list li.display-only {
  cursor: default;
  color: #f9fafb;
}
.anchor-list li.display-only::after {
  display: none;
}
.anchor-list li.active {
  color: #00acf8;
}
.anchor-list li.active::after {
  transform: scaleX(1);
}

.anchor-section {
  /* height: 100vh; */

  text-align: center;
}

.vision {
  position: relative;
  /* width: 100vw; */
  /* height: 100vh; */
  overflow: hidden;
  background: #00a8ff;
  /* padding-left: 4vw; */
}
.vision-container {
  width: 100%;
  height: 68vh;
  position: relative;
  background-repeat: no-repeat;
  background-position: right center;
  background-size: auto 100%;
  z-index: 2;
  display: flex;
}

@media screen and (min-width: 2500px) {
  .vision-container {
    height: 60vh;
  }
}

.vision-container-text {
  flex: 1;
  /* padding-left: 4vw; */
}
.vision-container-image {
  flex: 1.2;
  width: 100%; /* 你可以改成 100% */
  height: 100%; /* 高度自定义 */
  background-size: cover;
  background-repeat: no-repeat; /* 保持铺满 */
  background-position: center;

  overflow: hidden; /* 保证圆角外部不显示 */
  box-shadow: 0 4px 1.25rem rgba(0, 0, 0, 0.15); /* 阴影效果可选 */
  border-radius: 600px 0px 0px 0px;
}

.vision-textbg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1;
}

.vision-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: white;
  font-size: clamp(24px, 3vw, 48px); /* 文字大小最小24px，最大48px，可随屏幕略微缩放 */
  font-weight: bold;
  text-align: center;
  z-index: 2;
}

.brief {
  position: relative;
  /* height: 50%; */
  /* width: 100vw; */
  padding: 10rem 0; /* 控制垂直高度 */
  display: flex;
  justify-content: center;
  align-items: flex-start;
  background-color: white;
}

.brief-frame {
  max-width: 63vw;
  /* width: 70%; */
  /* padding: 1rem; */
  text-align: left;
}

.brief-title {
  margin-bottom: 1.9rem;
  text-align: center;
  color: black;
  font-size: var(--title-font-size);
  font-weight: bold;
  margin-top: 0rem;
}

.brief-content {
  /* line-height: 1.5; */

  /* color: black; */
  margin-bottom: var(--subThirdtitle-font-size) !important;
  font-size: 1.2rem;
  /* color: #3d3d3d; */
  line-height: 1.7rem;
  font-weight: 400;
}

.ip {
  position: relative;
  /* width: 100vw; */
  height: auto; /* 自动高度 */
  padding: 3.75rem 0;
  background-color: black;
  padding-bottom: 8.125rem;
}

.ip-frame {
  position: relative;
  width: 65vw;
  margin: 0 auto;
  text-align: center;
}

.ip-title {
  font-size: var(--title-font-size);
  font-weight: bold;
  color: white;
  margin-bottom: 6.25rem;
  margin-top: 3.75rem;
}

.ip-line {
  width: 65vw;
  height: 1px;
  background-color: #595a5c;
  margin: 0 auto 1.25rem auto;
}

.ip-detail {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1.25rem;
  margin-top: 3.125rem;
  /* margin-bottom: 40px; */
}

.location {
  position: relative;
  background-color: white;
  margin-bottom: 11.25rem;
  display: flex;
  width: 68vw;
  margin: 0 auto;
}

.locationSection {
  position: relative;
  padding: 6.25rem 0px;
  background-color: white;
  padding-bottom: 2rem;
}
.vision-container-wrap {
  display: flex;
  flex-direction: column; /* 竖排 */
  justify-content: center; /* 垂直居中 */
  align-items: flex-start;
  height: 100%;
  text-align: left; /* 居中文字 */
  color: white;
  padding-left: 6vw;
}

.vision-container-text-title div {
  font-size: var(--title-font-size);
  font-weight: bold;
  line-height: 1;
}

.vision-container-text-detail {
  width: 90%;
  margin-top: 1.9rem;
  font-size: 1.2rem;
  /* color: #3d3d3d; */
  line-height: 1.7rem;
  font-weight: 400;
}

.ourInvesters {
  border-top: 1px solid #d1c7c7;
  padding-top: 5rem;
  width: 63vw;
  margin: 0 auto;
  margin-top: 9rem;
}

.ourInvestersTitle {
  text-align: center;
  width: 62vw;
  margin: 0 auto;
  font-size: var(--title-font-size);
  font-weight: bolder;
  margin-bottom: 6.25rem;
}

.ourInvestersLogoContainer {
  position: relative;
  background-color: white;
  margin: 0 auto;

  display: grid;
  grid-template-columns: repeat(4, 25%); /* 一行四个 */
  /* flex-wrap: wrap; */
  row-gap: 5rem;
  justify-content: space-around;
  justify-items: center;
}

.ourInvestersLogo {
  width: 75%;
  align-self: center;
}

@media (min-width: 768px) and (max-width: 1700px), (max-height: 700px) {
  .vision-container {
    height: 650px;
  }
}

@media (max-width: 768px) {
  .vision-container {
    flex-direction: column; /* ✅ 改为上下布局 */
    width: 100%;
    gap: 4rem;
    height: auto;
  }

  /* 改变显示顺序：图片在上，文字在下 */
  .vision-container-image {
    order: 1;
    width: 100%;
    height: 60vh;
    border-radius: 0px;
  }

  .vision-container-text {
    order: 2;
    width: 100%;
    text-align: center;
  }
  .vision-container-wrap {
    left: 0vw;
    padding-left: 0vw;
    padding-bottom: 5rem;
  }

  .vision-container-text-detail {
    line-height: 1.7rem;
    text-align: left;
    width: 95%;
    padding: 0rem 20px 0;
  }
  .vision-container-text-title {
    text-align: left;
    padding-top: 5rem;
  }
  .brief {
    padding: 5rem 0;
  }
  .brief-frame {
    max-width: 100vw;
  }
  .brief-content {
    text-align: left;
    padding: 0rem 20px 0;
  }
  .ip {
    padding: 5rem 0;
  }
  .ip-title {
    margin-bottom: 3rem;
    margin-top: 0rem;
    font-size: 3rem;
    line-height: 3rem;
  }
  .ip-detail {
    margin-top: 0rem;
  }
  .ip-line {
    width: 90vw;
    margin-bottom: 0rem;
  }
  .ip-frame {
    width: 94vw;
  }

  .locationSection {
    padding: 5rem 0px 0px;
  }
  .locationTitle {
    /* word-break: break-all; */
    margin-bottom: 3rem;
    font-size: 3rem;
    line-height: 3rem;

    width: 98vw;
  }
  .location {
    flex-direction: column;
    width: 98vw; /* 移动端适配 */
  }
  .specialMargin {
    margin: 0rem !important;
  }
  .form-row {
    flex-direction: column;
    gap: 15px;
    margin-bottom: 0rem;
    margin-top: 0rem;
  }

  .form-item {
    flex: 1 1 100%;
  }

  button {
    width: 100%;
    padding: 18px 0;
    font-size: 1.2rem;
  }
  .addContract {
    padding-top: 5rem;
    width: 90%;
    margin: 0 auto;
    margin-top: 0rem;
  }
  .locationitem-name {
    top: 7px;
  }
  .vision-container-text-title div {
    padding: 0rem 20px 0;
    /* word-break: break-all; */
    margin-bottom: 2rem;
    font-size: 3rem;
    line-height: 3rem;
  }
  .vision-container {
    gap: 0rem;
  }
  .brief-title {
    padding: 0rem 20px 0;
    /* word-break: break-all; */
    margin-bottom: 2rem;
    font-size: 3rem;
    line-height: 3rem;
    text-align: left;
    word-wrap: break-word;
  }
  .form-container {
    padding: 5rem 0px;
  }
  .full-width {
    margin-top: 1rem;
    margin-bottom: 3rem;
  }
  .contractTitle {
    margin-bottom: 0rem;
  }

  .ourInvesters {
    padding-top: 5rem;
    padding-bottom: 5rem;
    width: 100%;
    margin: 0 auto;
  }
  .ourInvestersTitle {
    font-size: 3rem;
    margin-bottom: 3rem;
  }

  .ourInvestersLogoContainer {
    display: grid;
    grid-template-columns: repeat(2, 1fr); /* 一行两个 */
    gap: 20px; /* 间距 */
    justify-items: center;
    align-items: center;
    padding: 10px;
  }
  .ourInvestersTitle {
    width: 98vw;
  }

  .ourInvestersLogo {
    width: 60%;
    height: auto;
    object-fit: contain;
  }
}
</style>
